"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaAliases = exports.MediaLabels = void 0;
var MediaLabels;
exports.MediaLabels = MediaLabels;

(function (MediaLabels) {
  MediaLabels["xs"] = "smaller";
  MediaLabels["sm"] = "phone";
  MediaLabels["md"] = "tablet";
  MediaLabels["lg"] = "desktop";
  MediaLabels["xl"] = "giant";
})(MediaLabels || (exports.MediaLabels = MediaLabels = {}));

var MediaAliases;
exports.MediaAliases = MediaAliases;

(function (MediaAliases) {
  MediaAliases["smaller"] = "xs";
  MediaAliases["phone"] = "sm";
  MediaAliases["tablet"] = "md";
  MediaAliases["desktop"] = "lg";
  MediaAliases["giant"] = "xl";
})(MediaAliases || (exports.MediaAliases = MediaAliases = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-bootstrap-grid/dist/media/types.js
// module id = 164
// module chunks = 0